/**
 * Free email domain validation utility
 *
 * This module provides a comprehensive list of free email providers and
 * a validation function to check if a domain is a free email service.
 * Free email domains are typically not allowed for domain-based project invitations.
 */

export const FREE_EMAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "ymail.com",
  "yahoo.co.uk",
  "yahoo.co.in",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "msn.com",
  "aol.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "protonmail.com",
  "proton.me",
  "tutanota.com",
  "zoho.com",
  "zoho.eu",
  "zoho.in",
  "gmx.com",
  "gmx.co.uk",
  "mail.com",
  "mail.ru",
  "rambler.ru",
  "yandex.com",
  "yandex.ru",
  "yandex.by",
  "naver.com",
  "daum.net",
  "hanmail.net",
  "qq.com",
  "126.com",
  "163.com",
  "sina.com",
  "sina.cn",
  "188.com",
  "139.com",
  "wanadoo.fr",
  "orange.fr",
  "laposte.net",
  "free.fr",
  "alice.it",
  "libero.it",
  "virgilio.it",
  "tiscali.it",
  "btinternet.com",
  "talktalk.net",
  "sky.com",
  "virginmedia.com",
  "btopenworld.com",
  "o2.co.uk",
  "telus.net",
  "shaw.ca",
  "rogers.com",
  "sympatico.ca",
  "bell.net",
  "ntlworld.com",
  "web.de",
  "freenet.de",
  "hotmail.co.uk",
  "mailinator.com",
  "yopmail.com",
  "guerrillamail.com",
  "temp-mail.org",
  "10minutemail.com",
  "10minutemail.net",
  "throwawaymail.com",
  "maildrop.cc",
  "mailnesia.com",
  "getnada.com",
  "inbox.com",
  "hushmail.com",
  "hush.com",
  "tutanota.de",
  "hush.ai",
  "zoho.eu",
  "fastmail.com",
  "fastmail.fm",
  "posteo.de",
  "lavabit.com",
  "runbox.com",
  "openmailbox.org",
  "inbox.lv",
  "mail.bg",
  "email.cz",
  "seznam.cz",
  "centrum.cz",
  "wp.pl",
  "o2.pl",
  "onet.pl",
  "interia.pl",
  "libero.it",
  "aliceadsl.fr",
  "protonmail.ch",
  "protonmail.de",
  "protonmail.me",
  "tutanota.de",
  "tutamail.com",
  "1und1.de",
  "webmail.co.za",
  "zol.co.za",
  "iinet.net.au",
  "optusnet.com.au",
  "bigpond.com",
  "ozemail.com.au",
  "mail.com.au",
  "mailbox.org",
  "zoznam.sk",
  "centrum.sk",
  "seznam.cz",
  "gawab.com",
  "egyptianmail.com",
  "mail.kz",
  "mail.ee",
  "seznam.sk",
  "laposte.net",
  "libero.it",
  "hotmail.fr",
  "live.fr",
  "online.de",
  "seznam.net",
  "t-online.de",
  "webmail.co.uk",
  "inbox.ru",
  "tutanota.de",
  "protonmail.ch",
  "tutanota.at",
  "mailbox.hu",
  "freemail.hu",
  "centrum.hu",
  "riseup.net",
  "tutanota.co.uk",
  "protonmail.co.uk",
  "bloodymail.com",
  "yopmail.fr",
  "mailinator.net",
  "mintemail.com",
  "tempmail.net",
  "temp-mail.io",
  "tempinbox.com",
  "tempmailapp.com",
  "0box.eu",
  "spamgourmet.com",
  "spam4.me",
  "spamcowboy.com",
  "airmail.net",
  "mailbox.org",
  "protonmail.org",
  "tuta.io",
  "mailfence.com",
  "tutanota.com.au",
  "mailbox.cz",
  "myway.com",
  "zoho.com.au",
  "zoho.co.uk",
  "mynet.com.tr",
  "inbox.lv",
  "libero.it",
  "virgilio.it",
  "tin.it",
  "libero.it",
  "webmail.co.za",
  "yandex.ua",
  "ukr.net",
  "mail.ua",
  "i.ua",
  "inbox.ru",
  "mail.ru",
  "list.ru",
  "bk.ru",
  "mailinator.org",
  "temp-mail.org",
  "yopmail.net",
  "guerrillamail.net",
  "guerrillamail.org",
  "getairmail.com",
  "moakt.com",
  "tempmailo.com",
  "mailcatch.com",
  "mailfake.com",
  "mailexpire.com",
  "finallymail.com",
  "beepmail.de",
  "mintemail.com",
  "yopmail.org",
  "mail2world.com",
  "mail2web.com",
  "usa.com",
  "qqmail.com",
  "21cn.com",
  "263.net",
  "inmail.ru",
  "inbox.com.au",
  "blueyonder.co.uk",
  "lineone.net",
  "t-online.de",
  "virgin.net",
  "hush.ai",
  "mymail-in.net",
  "gmial.com",
  "hotmail.de",
  "hotmail.fr",
  "hotmail.it",
  "aim.com",
  "excite.com",
  "lycos.com",
  "india.com",
  "india.net.in",
  "rediffmail.com",
  "gmail.co.uk",
  "rocketmail.com",
  "email.it",
  "libero.it",
  "tiscali.co.uk",
  "webmail.co.za",
  "sina.com.cn",
  "yeah.net",
  "sohu.com",
  "21cn.com",
  "263.com",
  "chinesemail.com",
  "bol.com.br",
  "uol.com.br",
  "terra.com.br",
  "ig.com.br",
  "bol.com",
  "bolmail.com",
  "o2.pl",
  "vp.pl",
  "tlen.pl",
  "poczta.fm",
  "wp.com",
  "fastmail.co.uk",
  "fastmail.ca",
  "hushmail.ca",
  "meganet.net",
  "10mail.org",
  "mailbox2.com",
  "protonmail.de",
  "mail.ru.net",
  "athleticmail.com",
  "zohomail.com",
  "zoho.eu",
  "tutanota.eu",
  "myfastmail.com",
  "mail2me.com",
  "mail2king.com",
  "mail2x.com",
  "mail2usa.com",
  "usa.net",
  "ukr.net",
  "mail.kz",
  "bigfoot.com",
  "mail.coms",
  "cox.net",
  "comcast.net",
  "sbcglobal.net",
  "bellsouth.net",
  "embarqmail.com",
  "centurylink.net",
  "q.com",
  "rocketmail.co.uk",
  "inbox.com",
  "gmx.net",
  "gmx.de",
  "mail.com.tr",
  "inbox.com.tr",
  "netzero.net",
  "juno.com",
  "verizon.net",
  "earthlink.net",
  "frontiernet.net",
  "suddenlink.net",
  "frontier.com",
  "shaw.ca",
  "charter.net",
  "charter.com",
  "ziggo.nl",
  "home.nl",
  "planet.nl",
  "libero.it",
  "virgilio.it",
  "laposte.net",
  "numericable.fr",
  "sfr.fr",
  "neuf.fr",
  "ntlworld.com",
  "bluewin.ch",
  "bluewin.com",
  "blueyonder.co.uk",
  "talk21.com",
  "gawab.com",
  "libero.it",
  "sunny.net",
  "iname.com",
  "mail2easy.com",
  "mail2world.com",
  "mailforspam.com",
  "mail-temporaire.com",
  "fakemail.net",
  "mailcatch.com",
  "mailnesia.org",
  "yopmail.com.br",
  "mailnesia.com",
  "dayrep.com",
  "mailism.com",
  "mail-box.cc",
  "mmail.com",
  "33mail.com",
  "bag08.com",
  "bobmail.info",
  "mail-temp.com",
  "mailnesia.com",
  "moakt.com",
  "getairmail.com",
  "throwawaymail.org",
  "trashmail.com",
  "temp-mail.io",
  "trashmail.net",
  "yopmail.fr",
  "courrier.nu",
  "eclipso.eu",
  "mailbox.org",
  "tutanota.nl",
  "tutanota.ch",
  "tutanota.at",
  "tutanota.de",
  "protonmail.net",
  "protonmail.com.au",
  "protonmail.jp",
  "protonmail.org.uk",
  "posteo.de",
  "posteo.at",
  "posteo.ch",
  "vivaldi.net",
  "runbox.no",
  "runbox.com",
  "kolabnow.com",
  "mailbox.org",
  "safe-mail.net",
  "yandex.com.tr",
  "yandex.kz",
  "mail.by",
  "t-online.at",
  "t-online.ch",
  "gmail.de",
  "gmail.fr",
  "gmail.it",
  "gmail.ru",
  "gmail.co.jp",
  "gmx.at",
  "gmx.ch",
  "gmx.fr",
  "orange.es",
  "wanadoo.es",
  "tele2.se",
  "telia.se",
  "hotmail.se",
  "hotmail.no",
  "hotmail.dk",
  "live.se",
  "live.dk",
  "live.no",
  "citiz.net",
  "hushmail.co.uk",
  "cybergal.com",
  "bigstring.com",
  "usa.net",
  "jurnalist.com",
  "gmail.co.za",
  "inbox.co.za",
  "webmail.co.nz",
  "xtra.co.nz",
  "vodamail.co.nz",
  "paradise.net.nz",
  "optus.com.au",
  "internode.on.net",
  "tpg.com.au",
  "bigpond.net.au",
  "rogers.ca",
  "shawweb.com",
  "ukrpost.net",
  "tutamail.com",
  "tmail.com",
  "mailinater.com",
  "mailinator.co.uk",
  "yopmail.net",
  "cock.email",
  "mailtemp.info",
  "mailcatch.com.au",
  "robrom.com",
  "fakeinbox.com",
  "guerrillamail.biz",
  "guerrillamail.de",
  "guerrillamail.org",
  "inboxbear.com",
  "instaemail.net",
  "mailnesia.info",
  "spamdecoy.net",
  "spamgourmet.com",
  "spam.la",
  "spamavert.com",
  "disposablemail.com",
  "tempmail.in",
  "tempmail.pro",
  "33mail.info",
  "33mail.org",
  "anomail.net",
  "mailnull.com",
  "privaterelay.appleid.com",
  "proxymail.io",
  "privemail.com",
  "safemail.net",
  "secure-mail.biz",
  "secure-mail.org",
  "mailproxy.net",
  "mailboxproxy.com",
  "mail2trash.com",
  "burnermail.io",
  "simplelogin.io",
  "aliasmail.com",
  "recipmail.com",
  "forwards.app",
  "unblock.to",
  "emailn.de",
  "anonymbox.com",
  "incognito.email",
  "spambox.us",
  "spamhero.com",
  "spamgadget.com",
  "guerrillamailblock.com",
  "mailpoof.com",
  "tempail.com",
  "1secmail.com",
  "1secmail.org",
  "1secmail.net",
  "mail-temporaire.fr",
  "20minutemail.com",
  "yopmail.info",
  "tempmail.org.ua",
  "mytrashmail.com",
  "mailin8r.com",
  "trashymail.com",
  "spamex.com",
  "tmail.ws",
  "spam4.me",
  "spambox.info",
  "getairmail.info",
  "spamslicer.com",
  "throwawayemail.com",
  "deadfake.cf",
  "tempmail.xyz",
  "tempmailapp.dev",
  "disposablemail.de",
  "disposablemail.org",
  "flexmailbox.com",
  "fakebox.org",
  "ephemeral.email",
  "dummyemail.com",
  "yop.it",
  "maildrop.tk",
  "mailtemp.info",
  "spammyemail.com",
  "33mailbox.com",
  "mailbeez.com",
  "onet.eu",
  "emailtest.com",
  "mailtester.com",
  "test.com",
  "example.com",
  "example.net",
  "example.org",
  "postmaster.net",
  "postmaster.org",
  "contactme.com",
  "contactus.com",
  "mailbox.org.uk",
  "mail2me.org",
  "mail2ca.com",
  "mail2uk.com",
  "mail2au.com",
  "mail2fr.com",
  "mail2de.com",
  "mail2it.com",
  "mail2es.com",
  "mail2pl.com",
  "mail2ru.com",
  "mail2cn.com",
  "mail2jp.com",
  "mail2kr.com",
  "mail2br.com",
  "mail2mx.com",
  "mail2za.com",
  "mail2in.com",
  "mail2eg.com",
  "mail2ar.com",
]);

/**
 * Check if a domain is a free email provider
 *
 * @param domain - The domain to check (e.g., "gmail.com")
 * @returns true if the domain is a free email provider, false otherwise
 */
export function isFreeEmailDomain(domain: string): boolean {
  return FREE_EMAIL_DOMAINS.has(domain.toLowerCase());
}
